import * as types from './mutation-types'

export default {
  [types.SET_GARAGE] (state, payload) {
    state.garage = payload
  },
  [types.SET_CREDIT] (state, payload) {
    state.credit = payload
  },
  [types.SET_CREDIT_DATA] (state, payload) {
    state.credit_data = payload
  },
  [types.SET_CAR_SELECTED] (state, payload) {
    state.car_selected = payload
  },
  [types.SET_LOAD_GARAGE] (state) {
    state.load_garage = !state.load_garage
  },
  [types.SET_LOAD_CREDIT] (state) {
    state.load_credit = !state.load_credit
  },
  [types.SET_COLECAO] (state, payload) {
    state.colecoes = payload
  }
}
